import * as api from './base';

//投稿列表
export const index = (params) => api.get({
    url: "Contribution/index",
    params,
    loading: "加载中"
});

//投稿列表
export const contributionList = (page) => api.get({
    url: "Contribution/List?page=" + page,
    loading: "加载中"
});

//投稿详情
export const contributionDetail = (cbId) => api.get({
    url: "Contribution/GetDetail?cbId=" + cbId,
    loading: "加载中"
});

//提交投稿
export const contributionSubmit = (data) => api.post({
    url: "Contribution/Submit",
    data: data,
    loading: "正在提交"
});

// 联系人列表
export const getMemberContact = (params) => api.get({
	url: "membercontact/ContactList",
	params,
	loading: "加载中"
});

// 添加联系人
export const submitContact = (data) => api.post({
	url: "membercontact/SubmitContact",
	data,
	loading: "加载中"
});
// 修改联系人
export const modifyContact = (data) => api.post({
	url: "membercontact/ModifyContact",
	data,
	loading: "加载中"
});

// 确认银行
export const confirmBank = (data) => api.post({
	url: "contribution/confirmBank",
	data,
	loading: "加载中"
});

export const getContributionList = (page) => api.get({
	url: "Contribution/List?page=" + page,
	loading: "加载中"
})